<main *transloco="let t" class="container">
  <div class="row min-vh-100 align-items-center justify-content-center">
    <div class="col-12 col-md-8 col-lg-6 text-center">
      <div class="display-1 text-primary mb-5 fw-bold">404</div>
      <p class="not-found">
        <span class="text-primary">{{ t('shared/oops') }}</span
        ><br />{{ t('shared/notFound') }}
      </p>
      <p [innerHTML]="t('shared/contactSupport')"></p>
      <a type="button" class="btn btn-primary d-flex align-items-center fw-bold mx-auto" routerLink="/">
        <i class="material-symbols-rounded filled">arrow_back</i>
        <span>{{ t('shared/returnBack') }}</span>
      </a>
    </div>
  </div>
</main>
